import { makeStyles, tokens } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useManageSurveyTemplatesStyles = makeStyles({
  categoryPill: {
    backgroundColor: `${projectIqTokens.teal}22`,
    color: projectIqTokens.teal,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[2]}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
  },
  activeCell: {
    color: designTokens.semantic.success,
    fontWeight: designTokens.fontWeight.semibold,
    fontSize: designTokens.fontSize.sm,
  },
  inactiveCell: {
    color: tokens.colorNeutralForeground4,
    fontSize: designTokens.fontSize.sm,
  },
});
